/* eslint-disable @typescript-eslint/no-empty-function */
import styles from './Datepicker.module.css';
import { CalendarDayProps, DayButton, CalendarDay } from './Datepicker.styles';
import { isDateBefore, isSameDate } from './utilities';

export interface DayProps {
  day: Date;
  selected?: boolean;
  inRange?: boolean;
  inHoveringRange?: boolean;
  isHoverDate?: boolean;
  firstInRange?: boolean;
  lastInRange?: boolean;
  lastOfMonth: Date;
  disabled?: boolean;
  unavailable?: boolean;
  onClick?: (date: Date) => void;
  onHover?: (date: Date) => void;
}

export const Day = ({
  day,
  selected,
  inRange,
  inHoveringRange,
  isHoverDate,
  firstInRange,
  lastInRange,
  lastOfMonth,
  disabled,
  unavailable,
  onClick = () => {},
  onHover = () => {}
}: DayProps) => {
  const date = day.getDate();
  const today = isSameDate(day, new Date());
  const hoverDay = isDateBefore(day, lastOfMonth) ? day : lastOfMonth;

  const dateISOString = day.toISOString().split('T')[0];

  const dateLabel = day.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });

  const testId = disabled ? 'disabledDay' : `calendar-day-${dateISOString}`;

  const clickHandler = () => {
    if (disabled) {
      return;
    }

    onClick(day);
  };

  const calendarDayProps: CalendarDayProps = {
    selected,
    inRange,
    inHoveringRange,
    isHoverDate,
    firstInRange,
    lastInRange,
    unavailable,
    disabled,
    today
  };

  return (
    <CalendarDay
      {...(selected && { 'aria-selected': true, 'data-testid': 'selectedDay' })}
      {...(today && { 'data-testid': 'today' })}
      {...calendarDayProps}
    >
      <DayButton
        onClick={clickHandler}
        data-cv-test="button"
        data-testid={testId}
        data-analytics-id="pp_datepicker_select_day"
        aria-label={dateLabel}
        type="button"
        aria-disabled={disabled && !unavailable}
        {...calendarDayProps}
        onMouseOver={() => {
          onHover(hoverDay);
        }}
      >
        {date}
        {today && (
          <span
            className={selected ? styles.todayDotSelected : styles.todayDot}
            data-testid="today-dot"
          />
        )}
      </DayButton>
    </CalendarDay>
  );
};
